import { ApiClient } from './api/index.ts'
import type { SubscriptionDetails } from './api/types.ts'

/**
 * Get user's active subscriptions
 */
export async function getUserSubscriptions() {
  const result = await ApiClient.invoke<SubscriptionDetails>('subscription_get_details', {
    body: {},
  })

  if (!result.success) {
    // Extract user-friendly error message
    const errorMessage = result.error?.message || 'Failed to load subscriptions. Please try again.'
    throw new Error(errorMessage)
  }

  return result.data!
}

/**
 * Create a Stripe Customer Portal session for subscription management
 * Redirects user to Stripe-hosted portal for payment methods, invoices, cancellation
 */
export async function createPortalSession(returnUrl?: string): Promise<{ portal_url: string }> {
  const result = await ApiClient.invoke<{ portal_url: string }>('subscription_manage_portal', {
    body: {
      return_url: returnUrl || `${window.location.origin}/settings`,
    },
  })

  if (!result.success) {
    const errorMessage = result.error?.message || 'Failed to open management portal. Please try again.'
    throw new Error(errorMessage)
  }

  return result.data!
}
